<template>
  <div style="overflow: auto; height: 100%" ref="fadeWhenModelOpen">
    <div style="height:50px;" class="comm-settings-top-nav">
      <div class="col-md-12 p-0 justify-content-start h-100">
        <nav aria-label="breadcrumb" class="h-100">
          <ol class="breadcrumb comm-settings-top-nav m-0 h-100">
            <li><back-button  v-on:click.native="handleBackNavigation()" style="position: relative;bottom: 10px;inset-inline-start :-6px;"></back-button></li>
            <!-- <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{selectedCustomKeyName}}</li> -->
            </ol>
        </nav>
      </div>
    </div>
    <div class="set-height-of-div">
    <table class="table users-basic-info-table" style="background: transparent">
      <thead style="color: #eee">
        <tr>
          <th scope="col" style="width: 20%"></th>
          <th scope="col" style="width: 80%"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="key-div">{{$t('Name')}} *</td>
          <td id="field_name" class="value-div d-flex m-0">
            <input
              type="text"
              id="name_value"
              class="rounded text-light comm-input-field-style"
              v-model="keyInfo.name"
              placeholder="Enter screen profile name"
              autocomplete="off"
            />
          </td>
        </tr>
        <tr>
          <td class="key-div">{{$t('Load when')}}</td>
          <td id="field_name" class="value-div d-flex m-0">
            <load-type-filter v-bind="currentProperties" :newProfile=true ref="loadWhenBrowserDiv"
            @fadePage="handleFadePage"></load-type-filter>
          </td>
        </tr>
        <tr>
          <td class="key-div">Fields</td>
          <td id="field_name" class="value-div d-flex m-0" style="position: relative;bottom: 9px;">
            <div class="value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields">
                              <ul class="tags-display-ul p-0 w-100 m-0" style=" display: grid;">
                                <div style="display: grid;">
                                <li class="add-screens-styles" @click="enableFieldBrowser=true">
                                  <div style="margin-inline-end:10px">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                  </div>
                                  <div style="font-size: 15px;line-height: 55px;">{{$t('Add Field(s) to Screen profile')}}</div>
                                </li>
                                <li style="position:relative;inset-inline-end:5px">
                                  <div class="list-group-item view-tags" style="color:#EEEEEE" v-for="fieldId in keyInfo.custom_metadata_id_list" :key="fieldId">
                                      <div v-if='fieldId == "1"'>
                                        <div class="screen-tags-name-display">
                                            <div>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list drag-icon" viewBox="0 0 16 16">
                                                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                              </svg >
                                            </div>
                                            <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{$t('Tags')}}</div>
                                        </div>
                                        <div class="screen-tags-styles">
                                          <template v-if="keyInfo.tag_display_all == true">
                                            <div :key="tagId">
                                              <div class="view-sub-tags" style="background: #393939;border: 2px solid #000 !important;">
                                                <span>{{$t('ALL')}}</span>
                                                <cancel-icon class="show-tags-delete" @click.native="keyInfo.tag_display_all = !keyInfo.tag_display_all"
                                                 style="float: inline-end;text-align: end" title="Remove Tag"></cancel-icon>
                                              </div>
                                            </div>
                                          </template>
                                          <template v-for="tagId in keyInfo.tag_id_list" v-else>
                                            <div :key="tagId">
                                              <div class="view-sub-tags" style="background:#33691e">
                                                <span>{{getTagNamefromId(tagId)}}</span>
                                                <cancel-icon class="show-tags-delete" @click.native="removeTagId(tagId)"
                                                 style="float: inline-end;text-align: end" title="Remove Tag"></cancel-icon>
                                              </div>
                                            </div>
                                          </template>
                                          <div class="dropdown">
                                            <div class="nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                              <svg width="15" height="1.5em" viewBox="0 0 16 16" class="bi bi-three-dots more-actions-btn"  fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                              </svg>
                                            </div>
                                            <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                                                  <a class="dropdown-item p-2" :class="{activeClass:keyInfo.tag_display_all == false}" @click.stop.prevent="enableTagBrowser=true;keyInfo.tag_display_all=false">
                                                    {{$t('Add specific Tag(s)')}}</a>
                                                  <a class="dropdown-item p-2" :class="{activeClass:keyInfo.tag_display_all == true}" @click.stop.prevent="keyInfo.tag_display_all=true">
                                                    {{$t('Select all Tag(s)')}}</a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div v-else-if='fieldId == "Description"'>
                                          <div class="screen-tags-name-display">
                                            <div>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list drag-icon" viewBox="0 0 16 16">
                                                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                              </svg >
                                            </div>
                                            <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{$t('Description')}}</div>
                                          </div>
                                        </div>
                                        <div v-else-if='fieldId == "Catalogs"'>
                                          <div class="screen-tags-name-display">
                                            <div>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list drag-icon" viewBox="0 0 16 16">
                                                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                              </svg >
                                            </div>
                                            <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{$t('Catalogs')}}</div>
                                          </div>
                                        </div>
                                      <div v-else class="screen-tags-name-display">
                                            <div>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list drag-icon" viewBox="0 0 16 16">
                                                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                              </svg >
                                            </div>
                                            <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{ getFieldNamefromId(fieldId) }}</div>
                                      </div>
                                        <div class="screen-tags-styles">
                                          <cancel-icon class="show-main-tag-delete" @click.native="removeField(fieldId)"
                                           style="float: inline-end;text-align: end;margin:8px;height:25px !important;width:25px; !important"
                                           title="Remove Field"></cancel-icon>
                                        </div>
                                  </div>
                                </li>
                                </div>
                              </ul>
                          </div>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    <div class="primary-btn-style">
      <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"
        v-on:click="changeToSelectedMetadataProfileTableComponent('show-screen-profiles')" title="Cancel">Cancel</button>
      <button @click="createNewKey()" class="btn btn-outline-primary mr-3" data-v-198e7d7f=""  style="position: relative; float: inline-start; inset-inline-end :0px"
       title="Save Screen Profile">
        Save
      </button>
    </div>
    <field-browser ref="fieldBrowserDiv" v-if="enableFieldBrowser" :isEditGroup="false" :browseMultiFields="true" :isScreenProfile="true"
          :userNameIdMap='selectedFieldIdNameMap'
       :selectedIds='getLoadWhenFieldIds' @close='handleFieldSelection' screenType="ScreenProfiles"></field-browser>
    <tag-browser v-if="enableTagBrowser" :isEditGroup="false" 
          :userNameIdMap='selectedTagIdNameMap'
       :selectedIds='keyInfo.tag_id_list' @close='handleTagSelection'></tag-browser>
  </div>
</template>

<script>
import {mapActions} from "vuex"
import Utils from "../../components.utils.js";
import BackButton from "../core/backButton.vue";
import LoadTypeFilter from  "./LoadTypeFilter.vue"
import FieldBrowser from "../customMetadata/AddFieldsFromBrowser.vue"
import TagBrowser from "../tags/MultiTagBrowser.vue"
import CancelIcon from "../core/InlineCancelField.vue";

export default {
  data() {
    return {
      keyInfo: {
          "name":"",
          "custom_metadata_id_list":[],
          "tag_id_list":[],
          "tag_display_all":false
      },
      selectedFieldIdNameMap:{},
      enableFieldBrowser:false,
      enableTagBrowser:false,
      selectedTagIdNameMap:{},
    };
  },
  components:{
    "back-button":BackButton,
    "load-type-filter":LoadTypeFilter,
    "field-browser":FieldBrowser,
    "tag-browser":TagBrowser,
    "cancel-icon": CancelIcon,
  },
  computed:{
      currentProperties() {
        //Dynamically send props
        return { selectedScreenProfileID: "" };
      },
  },
  methods : {
    handleBackNavigation(){
      let exitPage = true;
      if(this.keyInfo.name.trim().length > 0){
        if(!confirm(
              `Unsaved data exists. \nYou will loose the edited data if exit from the page.`
        )){
          exitPage = false
        }
      }
      if(exitPage){
        this.changeToSelectedMetadataProfileTableComponent('show-screen-profiles');
      }
    },
    handleFadePage(opacityVal){
      console.log("opacity",opacityVal);
      // this.$refs.fadeWhenModelOpen.style.opacity = opacityVal;
    },
    //field's operation
    handleFieldSelection(fieldIds, fieldIdNameMap){
          this.$refs.fadeWhenModelOpen.style.opacity = 1;
          if(fieldIds == undefined){
            this.enableFieldBrowser = false;
            return;
          }
          let fIdNameMap = {};
          Object.assign(fIdNameMap, fieldIdNameMap);
          for(let fieldId of Object.keys(fIdNameMap)){
            if(!Object.keys(this.selectedFieldIdNameMap).includes(fieldId)){
              this.selectedFieldIdNameMap[fieldId] = fIdNameMap[fieldId];
            }
            if(fieldId == "1"){
             this.keyInfo.tag_display_all = true;
            }
          }
          for(let fieldId of fieldIds){
            if(!this.keyInfo.custom_metadata_id_list.includes(fieldId)){
              this.keyInfo.custom_metadata_id_list.push(fieldId);
            }
          }
          this.enableFieldBrowser = false;
    },
    getFieldNamefromId(fieldId){
          if(Object.keys(this.selectedFieldIdNameMap).includes(fieldId)){
            return this.selectedFieldIdNameMap[fieldId];
          }
          return "None";
    },
    removeField(fieldId){
          if(this.keyInfo.custom_metadata_id_list.includes(fieldId)){
            this.keyInfo.custom_metadata_id_list.splice(this.keyInfo.custom_metadata_id_list.indexOf(fieldId),1);
          }
    },
    //

    //Tag id's operations
    handleTagSelection(tagIds, tagIdNameMap){
          this.$refs.fadeWhenModelOpen.style.opacity = 1;
          if(tagIds == undefined){
            this.enableTagBrowser = false;
            return;
          }
          let tIdNameMap = {};
          Object.assign(tIdNameMap, tagIdNameMap);
          for(let tagId of Object.keys(tIdNameMap)){
            if(!Object.keys(this.selectedTagIdNameMap).includes(tagId)){
              this.selectedTagIdNameMap[tagId] = tIdNameMap[tagId];
            }
          }
          for(let tagId of tagIds){
            if(!this.keyInfo.tag_id_list.includes(tagId)){
              this.keyInfo.tag_id_list.push(tagId);
            }
          }
          this.enableTagBrowser = false;
    },
    getTagNamefromId(tagId){
          if(Object.keys(this.selectedTagIdNameMap).includes(tagId)){
            return this.selectedTagIdNameMap[tagId];
          }
          return "None";
    },
    removeTagId(tagId){
          if(this.keyInfo.tag_id_list.includes(tagId)){
            this.keyInfo.tag_id_list.splice(this.keyInfo.tag_id_list.indexOf(tagId),1);
          }
    },
    //
    changeToSelectedMetadataProfileTableComponent(compName, payload = {}){
        this.$emit("changeToSelectedMetadataProfileTableComponent", compName, payload)
    },
    createNewKey(){
      if(!Object.keys(this.keyInfo).includes('name') ||
        typeof this.keyInfo.name == "undefined" ||
        this.keyInfo.name.trim().length <= 0){
        alert("Please add profile name. ")
        document.getElementById("field_name").scrollIntoView();
        document.getElementById("name_value").focus();
        return
      }
      if(this.keyInfo.custom_metadata_id_list.includes("1")){
        this.keyInfo.custom_metadata_id_list.splice(this.keyInfo.custom_metadata_id_list.indexOf("1"),1);
      }
      this.keyInfo.load_when = this.$refs.loadWhenBrowserDiv.getLoadWhenDetails();
      console.log("thie.keyInfo.load_when",this.keyInfo.load_when)
      this.addNewMetadataProfile(this.keyInfo).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)){
          this.$toast.success(data.message);
          this.$emit("changeToSelectedProfileKeyComponent", "show-screen-profiles",{});
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    ...mapActions("metadataProfiles",["addNewMetadataProfile"]),
  }
};
</script>


<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$border-on-hover: 1px solid #61707d;

.input-fields{
    border: none;
    border-radius: 0px !important;
}

// .input-fields:focus{
//     outline: unset;
//     border-bottom: 1px solid #0373ee !important;
// }

.upload-fields{
    border: $border-color;
    width: 46%;
    border-radius: 5px;
    position:relative;
}

.users-basic-info-table {
  font-size: $input-field-and-label-font-size;
  max-height:100%;
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $secondary-text-color;
      border:none;
      line-height:39px;
      font-size:16px;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
      border:none;
    }
  }
}
table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      padding:0px !important;
      border:none;
    }
  }
  tbody {
    color: $text-color;
    padding:0px !important;
    border:none;
  }
  th{
      padding:0px !important;
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.view-tags {
    font-size: 12px!important;
    display: inline-flex!important;
    margin: 6px!important;
    border-radius: 15px!important;
    text-align: start;
    padding: 7px!important;
    justify-content: space-between;
    background:$primary-background;
    border:$border-color;
  span {
    margin-inline-start: 0px !important;
    font-size: 12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
    width: 90%;
  }
}

.drag-icon{
  color:$dull-text-color;
  cursor: grab;
}

.editIcon {
  margin-inline-start: 9px;
}

.view-tags:hover, .view-sub-tags:hover {
  border: $border-on-hover !important;
}

.view-tags .show-main-tag-delete, .more-actions-btn {
  visibility: hidden;
}

.view-tags:hover{
  .show-main-tag-delete, .more-actions-btn {
    visibility: visible;
  }
} 
.show-tags-delete{
  visibility: hidden;
}

.view-sub-tags:hover .show-tags-delete{
  visibility: visible;
}

.show-main-tag-delete {
  margin-inline-start: 5px;
  margin-inline-end: 5px;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block;
    width: 20px;
    height: 19px;
    margin-top: 0px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: .25em;
    background: $primary-background;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  position: absolute;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}


.secondary-btn-style:hover{
  text-decoration: underline;
}
.secondary-btn-style{
  color:$text-color;
}

.screen-tags-name-display{
  display:inline-flex;
  line-height:44px;
  width:33%;
}

.screen-tags-styles{
  display:inline-flex;
  .view-sub-tags{
    font-size: 12px!important;
    height: 30px;
    display: inline-flex!important;
    margin: 5px!important;
    border: $border-color!important;
    border-radius: 15px!important;
    min-width: 50px!important;
    padding: 0!important;
    text-align: start;
    width: auto!important;
    padding-inline-start: 12px!important;
    justify-content: start;
    padding-top: 2px!important;
    span {
      margin-inline-start: 0!important;
      font-size: 12px!important;
      border-radius: 15px!important;
      position: relative!important;
      top: 3px!important;
      width: 90%;
    }
    .show-tags-delete{
      margin: 3px!important;
      float: inline-end;
      text-align: end;
      width: 25px;
      height: 25px;
      color: $text-color;
      position: relative;
      bottom: 4px;
    }
  }
}

.screens-name-styles{
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tags-display-ul{
  list-style-type: none;
}

.add-screens-styles{
    display: inline-flex;
    height: 57px;
    border: 1px solid $add-button-border-color;
    border-radius: 10px;
    width: 97%;
    justify-content: center;
    line-height: 52px;
    color:$add-button-text-color;
}

.add-screens-styles:hover{
    border: 1px solid $add-button-border-on-hover;
    color:$add-button-text-color-hover;
}

.comm-input-field-style{
    background: $primary-background!important;
    width: 35% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
    }
  }
  tbody {
    color: $text-color;
  }
}

.show-main-tag-delete {
  margin-inline-start: 5px;
  margin-inline-end: 5px;
}

.view-tags .show-main-tag-delete, .more-actions-btn {
  visibility: hidden;
}

.view-tags:hover{
  .show-main-tag-delete, .more-actions-btn {
    visibility: visible;
  }
}

.editIcon {
  margin-inline-start: 9px;
}

.view-tags:hover {
  border: $border-color !important;
}

.tags-display-ul .show-tags-delete {
  visibility: hidden;
}

.tags-display-ul li:hover .show-tags-delete {
  visibility: visible;
}

.show-tags-delete {
  margin-inline-start: 1px;
  margin-inline-end: 5px;
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}

.primary-btn-style {
  margin-top: 1%;
  position: absolute;
  inset-inline-start:22%;
  bottom: 15px;
  button {
    height: 35px;
    width: 70px;
    font-size:14px;
  }
}

label{
    position: relative;
    bottom: 4px;
    inset-inline-start:2px;
}

.searched-metadata-display-fields{
  height: auto;
  width: 82%;
  overflow:auto;
}

.set-height-of-div{
  height: calc(100vh - 190px);
  overflow:auto;
  position:relative;
  top:20px;
}

.list-group-item {
  width:97%;
}

.activeClass{
  color:$active-blue;
}
</style>